import { Injectable } from '@angular/core'
import { BaseConversationConfigProvider, IConversationTypeConfig } from '@engineering11/messaging-web'
import { ConversationTypes, DEFAULT_CONVERSATION_CONFIG } from '../../constants'

@Injectable({ providedIn: 'root' })
export class ApplicationConversationConfigProvider extends BaseConversationConfigProvider {
  conversationType = ConversationTypes.JobApplication
  private config: IConversationTypeConfig = {
    ...DEFAULT_CONVERSATION_CONFIG,
    maxMinutesToEditOwnMessages: 15,
    numberOfEditOwnMessages: 5,
  }

  getConfig(): IConversationTypeConfig {
    return this.config
  }

  setConfig(config?: Partial<IConversationTypeConfig>): void {
    this.config = { ...this.config, ...config }
  }
}
